<template>
  <div class="changePasswordContainer"
  >
    <div class="dialogContainer">
      <div id="closeButton" @click="onClose">X</div>
      <div class="pwTitle">비밀번호 변경</div>
      <input
          id="inputPw"
          v-model="password"
          type="password"
          class="inputItem"
          placeholder="현재 비밀번호 입력"
      >
      <input
          id="inputNewPw"
          v-model="newPassword"
          type="password"
          class="inputItem"
          placeholder="새 비밀번호 입력"
      >
      <input
          id="inputNewPwConfirm"
          v-model="newPasswordConfirm"
          type="password"
          class="inputItem"
          placeholder="새 비밀번호 확인"
      >
      <div id="saveButton" @click="onSave">저장</div>
    </div>
  </div>
</template>

<script>
import {api} from "../../../mixins/api";

export default {
  name: "dlconChangePassword",
  data() {
    return {
      password: null,
      newPassword: null,
      newPasswordConfirm: null,
    }
  },
  methods: {
    async onSave() {
      if (this.newPassword !== this.newPasswordConfirm) {
        alert('새 비밀번호가 일치하지 않습니다.')
        return;
      }

      // https://stackoverflow.com/questions/5859632/regular-expression-for-password-validation/5859963
      // 영어 소문자, 대문자, 특수문자
      // 최소 6글자 최대 15글자
      if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,15}$/.test(this.newPassword)) {
        alert('영어 소문자, 대문자, 숫자, 특수문자가 하나 이상 포함되어야합니다.\n(최소 6글자, 최대 16글자)');
        return;
      }
      else {
        let response = await api.methods.changePasswordApi(this.password, this.newPassword);
        if (response && response.status === 200) {
          this.$store.commit("setRefreshToken", response.data);
          alert('패스워드가 변경되었습니다.');
          this.$router.push('/dlcon/profile');
        } else {
          alert('패스워드 변경 실패');
        }
      }
    },
    onClose() {
      this.$router.push('profile');
    }
  }
}
</script>

<style scoped>
.changePasswordContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #D2D2D2;
}

.dialogContainer {
  position: relative;
  background: #FFFFFF;
  box-shadow: 0px 4px 40px rgba(51, 51, 51, 0.1);
  border-radius: 30px;
  width: 760px;
  height: 456px;
}

#closeButton {
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 24px;
  color: #A5A5A5;
}

#closeButton:hover {
  cursor: pointer;
}

.pwTitle {
  margin-top: 64px;
  margin-left: 80px;
  margin-bottom: 40px;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: #333333;
}

.inputItem {
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.6px;
  display: block;
  margin-left: 80px;
  margin-bottom: 12px;
  border-bottom: 1.5px solid #D2D2D2;
  width: 600px;
  padding: 20px;
}
.inputItem::placeholder {
  color: #A5A5A5;
}

#saveButton {
  position: absolute;
  width: 151px;
  height: 50px;
  left: calc(50% - 151px/2 + 224.5px);
  top: calc(50% - 50px/2 + 155px);

  background: #333333;
  border-radius: 100px;
  font-size: 18px;
  line-height: 18px;
  /* identical to box height */

  letter-spacing: -0.474667px;
  text-align: center;
  padding-top: 16px;


  /* Primary/white */

  color: #FFFFFF;
}

#saveButton:hover {
  cursor: pointer;
}

</style>
